<template>
  <div>
    <v-navigation-drawer
      app
      permanent
      clipped
      width="200"
    >
      <v-divider />
      <v-list>
        <v-list-tile v-for="page in pages" :key="page.text" :to="page.path">
          <v-list-tile-action>
            <v-icon>{{ page.icon }}</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>{{ page.text }}</v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>
    <v-container>
      <router-view />
    </v-container>
  </div>
</template>

<script>
import { auth } from '@/plugins/firebase';

export default {
  data: () => ({
    pagesBase: [
      { text: 'Properties', path: '/admin/properties', icon: 'location_city' },
      { text: 'Tenants', path: '/admin/tenants', icon: 'people' },
      { text: 'Owners', path: '/admin/owners', icon: 'people' },
      { text: 'Accounting', path: '/admin/accounting', icon: 'pie_chart' },
      { text: 'Maintenance', path: '/admin/maintenance', icon: 'subtitles' },
      { text: 'Account', path: '/admin/account', icon: 'person' },
    ],
  }),
  computed: {
    pages() {
      return auth.currentUser.emailVerified
        ? this.pagesBase
        : [
          ...this.pagesBase,
          { text: 'Verify Email', path: '/admin/verify', icon: 'email' },
        ];
    },
  },
};
</script>

<style></style>
